import { render, staticRenderFns } from "./taskIntro.vue?vue&type=template&id=bed42fde&scoped=true&"
import script from "./taskIntro.vue?vue&type=script&lang=js&"
export * from "./taskIntro.vue?vue&type=script&lang=js&"
import style0 from "./taskIntro.vue?vue&type=style&index=0&id=bed42fde&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed42fde",
  null
  
)

export default component.exports